import {Button} from "antd";
import React from "react";
import {withRouter} from "react-router-dom";
import {useSelector} from "react-redux";
import {subMerchantMaterialInfoSelector} from "../../../store/merchant";
import {MATERIAL_FILL_STEP, SELECTED_ORGANIZATION} from "../wechatSubMchApplicationStep";
import _ from 'lodash';

const StepController = (props) => {
    let {preStepButtonName, nexStepButtonName, resetMaterial, refresh, nextStepAction} = props;
    let {step} = useSelector(subMerchantMaterialInfoSelector);
    const history = props.history;
    const prevStep = () => {
        if (resetMaterial === undefined || resetMaterial === false) {
            if (step > 0) {
                let preStep = step - 1;
                setTimeout(() => {
                    history.push({
                        search: 'step=' + preStep,
                    });
                }, 500);
            }
        } else {
            setTimeout(() => {
                history.push({
                    search: 'step=' + SELECTED_ORGANIZATION,
                });
            }, 500);
        }
    };
    const nextStep = async () => {
        let passed = null;
        if (nextStepAction !== null && _.isFunction(nextStepAction)) {
            passed = await nextStepAction(step, step + 1);
        } else {
            if (nextStepAction === undefined) {
                passed = true;
            } else {
                passed = false;
            }
        }
        if (passed) {
            if (passed !== true && ['step'] !== undefined) {
                step = passed['step'];
            }
            if (refresh === true) {
                setTimeout(() => {
                    history.push({
                        search: 'step=' + step + '&refresh_time=' + Date.now(),
                    });
                }, 500);
            } else {
                let nextStep = step + 1;
                setTimeout(() => {
                    history.push({
                        search: 'step=' + nextStep,
                    });
                }, 500);
            }
        }
    };
    return (
        <div className='nextStep'>
            <div className='stepCtrl flex'>
                {preStepButtonName ? (
                    <Button className='themebtn prev' onClick={prevStep}>{preStepButtonName}</Button>) : null}
                {nexStepButtonName ? (
                    <Button className='themebtn' onClick={nextStep}>{nexStepButtonName}</Button>) : null}
            </div>
        </div>
    );
};

export default withRouter(StepController);